import { useField } from "formik";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CheckboxField(props: any) {
  const { errorText, infoMsg, ...rest } = props;
  const [field] = useField(props);
  const { t } = useTranslation();
  return (
    <FormGroup {...rest}>
      <FormControlLabel
        control={<Checkbox checked={field.value} {...field} />}
        label={t(props.label)}
      />
    </FormGroup>
  );
}
